import React from "react";

import destination_1 from "../../public/wheretogo-sumava/chalupskaslat/destination_1.png";
import destination_2 from "../../public/wheretogo-sumava/chalupskaslat/destination_2.png";
import destination_3 from "../../public/wheretogo-sumava/chalupskaslat/destination_3.png";
import destination_4 from "../../public/wheretogo-sumava/chalupskaslat/destination_4.png";
import destination_5 from "../../public/wheretogo-sumava/chalupskaslat/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-sumava/chalupskaslat/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-sumava/chalupskaslat/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-sumava/chalupskaslat/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-sumava/chalupskaslat/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const ChalupskaSlat = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Chalupská slať</h1>
            <p>
              Chalupská slať leží v mělkém údolí Vydřího potoka ve výšce 910 m,
              severně od Borové Lady. Kolem největšího rašelinového jezírka v ČR
              roste rašelinná kleč, srmky, borovice blatka či suchopýr pochvatý.
              K jezírku, na kterém se tvoří plovoucí ostrůvky, vede přes
              rašeliniště krátká naučná stezka.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>rašeliniště</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>vzácná fauna a flóra</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>naučná stezka</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>vstup zdarma</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Chalupská slať začala vnikat po skončení doby ledové před 8 až
                  10 tisíci lety. Základem pro vznik rašeliniště se stalo mělké
                  pánevní jezírko. Tento odolný mechorost se na slatích
                  vyskytuje v asi 20 druzích.
                </li>
                <li>
                  Slať leží na levém břehu Teplé Vltavy nad jejím soutokem s
                  Vydřím potokem. Nachází se zde Chalupské jezírko, největší
                  rašelinné jezero v Česku – má rozlohu 1,3 ha. V jezírku je
                  několik plovoucích ostrůvků.
                </li>
                <li>
                  V roce 1963 byla vyhlášena Chráněná krajinná oblast Šumava a
                  Chalupská slať prohlášena za státní přírodní rezervaci. Z
                  původního záměru, kdy měla být zdejší rašelina ještě spolu s
                  Jezerní slatí (list Kvilda) těžena, zcela sešlo.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChalupskaSlat;
